import React, { useState } from 'react';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import Typography from '@mui/joy/Typography';
import { styled } from '@mui/joy/styles';
import Sheet from '@mui/joy/Sheet';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';


import AboutUsForm from '../../Components/StaticPages/AboutUsComponent';
import TermsAndConditionsComponent from '../../Components/StaticPages/TermsAndConditions';
import ContactUsComponent from '../../Components/StaticPages/ContactUsComponent';
import PrivacyAndPolicyComponent from '../../Components/StaticPages/PrivacyAndPolicy';
import CommissionComponent from '../../Components/StaticPages/Commission';
import TaxComponent from '../../Components/StaticPages/Tax';
import CopyRightComponent from '../../Components/StaticPages/copyRight';
import UploadFileModels from '../../Components/StaticPages/UploadFileModels';


export default function StaticPages() {
    const [currentTab, setCurrentTab] = useState(0)

    const currentValue = (event, newValue) => {
        setCurrentTab(newValue)
        console.log(newValue)

    }
    return (
        <Tabs
            variant='plain'
            aria-label="Pricing plan"
            defaultValue={0}
            onChange={currentValue}
            sx={{
                width: '100%',
                borderRadius: 'sm',
                // boxShadow: 'sm',
                overflow: 'auto',
                backgroundColor: '#FBFBFB',
            }}
        >
            <TabList
                disableUnderline
                tabFlex={1}
                size='lg'
                sx={{
                    width: '100% !important',
                    [`& .${tabClasses.root}`]: {
                        fontSize: 'sm',
                        fontWeight: 'lg',
                        bgcolor: '#FBFBFB',

                        [`&[aria-selected="true"]`]: {
                            color: 'primary.500',
                            bgcolor: '#F7F9FB',
                        },
                        [`&.${tabClasses.focusVisible}`]: {
                            outlineOffset: '-4px',
                        },
                    },
                }}
            >
                <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                    من نحن
                </Tab>
                <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                    الشروط و الاحكام
                </Tab>
                <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                    سياسة الخصوصية   
                </Tab>
                <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                    اتصل بنا
                </Tab>
                <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                     جميع الحقوق محفوظه
                </Tab>
                <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                    العمولة    
                </Tab>
                <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                    الضريبة  
                </Tab>
                {/* <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                    رفع ملف الموديلات  
                </Tab> */}
            </TabList>

            <TabPanel value={0} sx={{ backgroundColor: '#F7F9FB' }}>
                <AboutUsForm/>
            </TabPanel>
            <TabPanel value={1} sx={{ backgroundColor: '#F7F9FB' }}>
                <TermsAndConditionsComponent/>
            </TabPanel>
            <TabPanel value={2} sx={{ backgroundColor: '#F7F9FB' }}>
                <PrivacyAndPolicyComponent/>
            </TabPanel>
            <TabPanel value={3} sx={{ backgroundColor: '#F7F9FB' }}>
                <ContactUsComponent/>
            </TabPanel>
            <TabPanel value={4} sx={{ backgroundColor: '#F7F9FB' }}>
                <CopyRightComponent/>
            </TabPanel>
            <TabPanel value={5} sx={{ backgroundColor: '#F7F9FB' }}>
                <CommissionComponent/>
            </TabPanel>
            <TabPanel value={6} sx={{ backgroundColor: '#F7F9FB' }}>
                <TaxComponent/>
            </TabPanel>
            {/* <TabPanel value={6} sx={{ backgroundColor: '#F7F9FB' }}>
                <UploadFileModels/>
            </TabPanel> */}
        </Tabs>
    )
}